import { useState, useEffect, useCallback } from 'react';
import { analyticsService } from '../services/analytics';
import { SentimentTrendsResponse } from '../types/analytics';
import { getApiErrorMessage } from '../utils/errors';

export const useSentimentTrends = (
  providerId: number | null,
  period: string = 'daily',
  days: number = 30
) => {
  const [data, setData] = useState<SentimentTrendsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTrends = useCallback(async () => {
    if (!providerId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const result = await analyticsService.getSentimentTrends(providerId, period, days);
      setData(result);
    } catch (err: any) {
      setError(getApiErrorMessage(err, 'Failed to fetch sentiment trends'));
      console.error('Error fetching sentiment trends:', err);
    } finally {
      setLoading(false);
    }
  }, [providerId, period, days]);

  useEffect(() => {
    fetchTrends();
  }, [fetchTrends]);

  return { data, loading, error, refresh: fetchTrends };
};
